import React from 'react';
import NavBar from '../../pages/NavBarPage';
import { Footer } from '../../pages/FooterPage';
import { useSystemMessage } from '../../hooks/useSystemMessage';

const UnauthorizedMessage = () => {
  const title = useSystemMessage('UnauthorizedPageTitle', 'Not Authorized!');
  const message = useSystemMessage('UnauthorizedPageHeader', 'Sorry! you are not authorized to view this page.');

  return (
    <div>
      <div id="wrapper">
        <NavBar />
        <div className="ml-16 p-4 w-full mt-12">
          <div className="w-full p-4">
            <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded">
              <h2 className="text-lg font-semibold mb-2">{title}</h2>
              <p>{message}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UnauthorizedMessage;